export default "__VITE_ASSET__qJJZTevw__"